"use client";

import { c as _c } from "react/compiler-runtime";
import { constructionStatus } from "@/info/unit/constructionStatus";
import * as Slider from "@radix-ui/react-slider";
import { useState } from "react";
interface PossessionSectionProps {
  value: string;
  onChange: (value: string) => void;
  showShortLabel?: boolean;
}

// Get the Under Construction options for possession
const possessionScale = constructionStatus.find(status => status.value === "underConstruction")?.options || [];
export function PossessionSection(t0) {
  const $ = _c(35);
  const {
    value,
    onChange,
    showShortLabel
  } = t0;
  const [showTooltip, setShowTooltip] = useState(false);
  const findClosestIndex = _temp;
  const t1 = value || "";
  let currentSliderIndex;
  let handleSliderChange;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== onChange || $[1] !== showTooltip || $[2] !== t1) {
    currentSliderIndex = findClosestIndex(t1);
    let t6;
    if ($[9] !== onChange) {
      t6 = newIndices => {
        const newIndex = newIndices[0];
        const newValue = possessionScale[newIndex]?.value;
        if (newValue) {
          onChange(newValue);
        }
      };
      $[9] = onChange;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    handleSliderChange = t6;
    const formatValueLabel = _temp2;
    t5 = "space-y-6";
    t4 = "relative pt-8";
    t2 = "relative h-5";
    t3 = showTooltip && <div className="absolute -top-12 bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap z-10 pointer-events-none" style={{
      left: `${currentSliderIndex / (possessionScale.length - 1) * 100}%`,
      transform: "translateX(-50%)"
    }}>{formatValueLabel(currentSliderIndex)}</div>;
    $[0] = onChange;
    $[1] = showTooltip;
    $[2] = t1;
    $[3] = currentSliderIndex;
    $[4] = handleSliderChange;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    currentSliderIndex = $[3];
    handleSliderChange = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[11] !== currentSliderIndex) {
    t6 = [currentSliderIndex];
    $[11] = currentSliderIndex;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShowTooltip(false);
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Slider.Track className="bg-gray-300 relative grow rounded-full h-1"><Slider.Range className="absolute bg-gray-500 rounded-full h-full" /></Slider.Track>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Slider.Thumb aria-label="Possession Timeline" className="block w-6 h-6 bg-white border-2 border-gray-500 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50" onMouseDown={() => setShowTooltip(true)} onTouchStart={() => setShowTooltip(true)} />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleSliderChange || $[17] !== t6) {
    t10 = <Slider.Root className="relative flex items-center select-none touch-none w-full h-5" value={t6} onValueChange={handleSliderChange} onValueCommit={t7} min={0} max={possessionScale.length - 1} step={1}>{t8}{t9}</Slider.Root>;
    $[16] = handleSliderChange;
    $[17] = t6;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t2 || $[21] !== t3) {
    t11 = <div className={t2}>{t3}{t10}</div>;
    $[19] = t10;
    $[20] = t2;
    $[21] = t3;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== currentSliderIndex || $[24] !== showShortLabel) {
    t12 = possessionScale.map((option, index_1) => {
      const isSelected = index_1 === currentSliderIndex;
      const isFirst = index_1 === 0;
      const isLast = index_1 === possessionScale.length - 1;
      const leftPosition = index_1 / (possessionScale.length - 1) * 100;
      return <div key={option.value} className="absolute flex flex-col items-center" style={{
        left: `${leftPosition}%`,
        transform: isFirst ? "translateX(0%)" : isLast ? "translateX(-100%)" : "translateX(-50%)"
      }}><div className={`w-px h-2 ${isSelected ? "bg-primary-600" : "bg-gray-400"}`} /><span className={`text-xs font-semibold ${isSelected ? "text-primary-600" : "text-gray-600"} whitespace-nowrap`}>{showShortLabel ? option.shortLabel : option.label}</span></div>;
    });
    $[23] = currentSliderIndex;
    $[24] = showShortLabel;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <div className="relative mt-4 pb-4">{t12}</div>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t4) {
    t14 = <div className={t4}>{t11}{t13}</div>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t4;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t5) {
    t15 = <div className={t5}>{t14}</div>;
    $[32] = t14;
    $[33] = t5;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
function _temp2(index_0) {
  const item_0 = possessionScale[index_0];
  return item_0 ? item_0.label : "";
}
function _temp(val) {
  if (!val) {
    return 0;
  }
  const index = possessionScale.findIndex(item => item.value === val);
  return index >= 0 ? index : 0;
}